/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trip_Stat_DatesInputs */

const en_ui_trip_stat_dates = /** @type {(inputs: Ui_Trip_Stat_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dates`)
};

const de_ui_trip_stat_dates = /** @type {(inputs: Ui_Trip_Stat_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Dates" |
*
* @param {Ui_Trip_Stat_DatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trip_stat_dates = /** @type {((inputs?: Ui_Trip_Stat_DatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trip_Stat_DatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trip_stat_dates(inputs)
	return de_ui_trip_stat_dates(inputs)
});